var _g, _g2, _tspan, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "600px",
    height: "600px",
    viewBox: "0 0 200 200",
    style: {
      overflow: "hidden!important"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-wrapper"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-backs-single"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11809",
    d: "M58.6 164.6s47.6 7 84.6.2c0 0 3.1-70.8-1.9-80.7s-75.1-17.4-80.7 1-3.4 72-2 79.5z",
    fill: "#1f140c",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanbody-back"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11169",
    d: "m168.5 219.5-1.7-21.5s.7-9-8.8-15.3-23.4-10.1-29.5-14.2c-6.1-4.1-9.2-4.5-9-16.9s.9-40.3.9-40.3H79.6s.7 27.9.9 40.3c.2 12.4-2.9 12.8-9 16.9-6.1 4.1-20 7.9-29.5 14.2S33.2 198 33.2 198l-1.6 21.5h136.9z",
    fill: "#f3d4cf",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-chinshadow-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11165",
    d: "M80.4 155.4c5.9 5.8 12.6 9.3 19.6 9.3s13.7-3.5 19.6-9.3c-.1-1.1-.1-2.4-.1-3.8.2-12.4.9-40.3.9-40.3H79.6s.7 27.9.9 40.3c0 1.4 0 2.7-.1 3.8z",
    fill: "#d4958a",
    strokeWidth: "none",
    opacity: 0.65,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanbody-front"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11170",
    d: "M73.8 175.9c5.1 2.9 11.8 5.2 17.6 5.7.4 0 .4-.6.1-.7-2.8-1.1-5.9-1.7-8.8-2.6-2.9-.9-5.8-2-8.8-2.7-.1-.1-.3.2-.1.3zm35.2 6.2c5.3-.6 11.3-3 15.9-5.8.3-.2.1-.6-.2-.5-2.6.9-5.2 2-7.8 2.9-2.6.9-5.4 1.5-8 2.5-.5.1-.5.9.1.9z",
    fill: "#d4958a",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11171",
    d: "m168.4 219.4-2.1-21.4c0-2.2-.5-4.5-1.5-6.6-.9-2.1-2.3-3.9-3.9-5.5s-3.5-2.8-5.5-4c-2-1.2-4.1-2.2-6.2-3.1-4.2-1.9-8.6-3.6-12.9-5.4-2.2-.9-4.3-1.9-6.4-3-1.1-.6-2.1-1.2-3-1.9-1-.6-2-1.2-3-1.9s-2-1.5-2.8-2.6c-.8-1-1.3-2.2-1.7-3.4-.7-2.4-.8-4.8-.8-7.2 0-4.7.2-9.4.3-14.1.2-9.4.6-18.7.9-28l.6.6-20.4-.2-20.4-.1.3-.3.7 28c.1 4.7.3 9.3.4 14 0 2.4-.1 4.7-.8 7.1-.3 1.2-.9 2.3-1.6 3.3-.8 1-1.7 1.8-2.7 2.5s-2 1.3-2.9 2c-.9.6-1.9 1.3-3 1.9-2.1 1.2-4.2 2.1-6.4 3.1-4.3 1.9-8.6 3.6-12.8 5.6-2.1 1-4.2 2.1-6.1 3.2-2 1.2-3.8 2.4-5.4 4-1.6 1.6-2.9 3.4-3.8 5.4-.4 1-.8 2.1-1 3.1-.2 1.1-.4 2.2-.3 3.2v.2l-1.5 21.5-1-1.1 34 .1c11.3 0 22.7.1 34.1.2l34.2.3 34.4.5zm.2.2-34 .4-34.2.3c-11.4.1-22.9.2-34.4.2l-34.4.1h-1.1l.1-1.1 1.7-21.5v.1c-.1-5.1 2.2-9.8 5.7-13.3 1.7-1.7 3.8-3.1 5.8-4.3 2-1.2 4.2-2.2 6.3-3.2 4.3-2 8.7-3.7 13-5.4 2.1-.9 4.3-1.8 6.3-2.9 1-.5 1.9-1.1 3-1.8 1-.6 2-1.2 2.9-1.9.9-.6 1.8-1.4 2.4-2.2.7-.9 1.2-1.9 1.5-2.9.6-2.1.8-4.5.8-6.8 0-4.6-.1-9.3-.2-14l-.6-28v-.3h.3l20.4-.1 20.4-.2h.6v.6c-.1 9.3-.2 18.7-.4 28-.1 4.7-.2 9.4-.2 14 .1 2.3.2 4.6.8 6.7.3 1.1.8 2 1.4 2.9.6.8 1.4 1.6 2.4 2.2.9.6 1.9 1.3 2.9 1.9 1 .7 1.9 1.3 2.9 1.8 2 1.1 4.1 2.1 6.3 3 4.3 1.8 8.6 3.6 12.9 5.6 2.1 1 4.2 2.1 6.2 3.3 2 1.2 4 2.6 5.7 4.3 3.4 3.4 5.6 8.1 5.4 13v-.1l1.4 21.6zm-112.8-.4 1.9-13.8.1 13.8h-2zm88.6 0-1.9-13.8-.1 13.8h2z",
    fill: "#c5796d",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-clothes-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11326",
    d: "M172 220s-1.3-17.2-2.6-22.7-4-12.6-5.1-13.4c-1.1-.9-1.9-.4-1.9-.4s-1.1-.9-4.5-3.4-18.5-7.2-20.4-8.5c-1.9-1.3-10.2-4.7-10.2-4.7l.2-2.3s-2.6-1.9-3.4-3.4c-.8-1.5-1.3-3.6-1.3-3.6l-.4-2.5s-.6 2-1 3.3-1 6.5-1.5 8.8c-.3 1.5-2.2 4.6-3.5 6.1-1.5 1.6-3.8 3-6.1 4.2-3.4 1.8-4.8 2.4-5.4 3.1-.6.7-.9 2.9-1.9 6l-1.1 2.6s-2.9-3.9-4.5-6.4c-1.6-2.5-3.1-3.4-4-3.4s-5.7.1-6.1-.2-1.8-1.7-2.4-2.8c-.7-1.1-3.4-8.1-4.1-9.5-.7-1.4-2-7.2-2.4-8.5-.3-1.3-.6-3.1-.6-3.1l-.4 1.1s-.8 3.4-1.7 4.9c-.8 1.5-3.4 3.4-3.4 3.4l.2 2.3s-8.3 3.4-10.2 4.7c-1.9 1.3-17 6-20.4 8.5s-4.5 3.4-4.5 3.4-.8-.4-1.9.4c-1.1.9-3.8 7.9-5.1 13.4S28 220 28 220",
    fill: "#386e77",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11327",
    d: "M163.9 185.7c-.1-.4-.8-.2-.7.2 2.9 9.4 4.1 19.1 5.7 28.8 0 .2.4.1.4-.1.6-10-1.9-19.6-5.4-28.9zm-3.1-1.1c-2.3 4.8-3.6 10.2-3.9 15.5 0 .2.3.2.3 0 .8-5.4 2.1-10.3 3.9-15.5 0 0-.2-.1-.3 0zm-59.6 12.5c-.2-.1-.4-.2-.2-.4.3-.3-.1-.7-.4-.6-1 .4-.1 2.1.7 1.4.1-.1 0-.3-.1-.4zm-.4 16.4c0-.2-.2-.3-.4-.1-.6.5 0 1.6.7 1.3.1 0 .1-.2 0-.2-.1-.4-.3-.6-.3-1zm6.9-31.2c-.3 0-.7-.1-.7-.5 0-.2-.4-.3-.4-.1-.1.4 0 .7.3.9.3.2.7.2.9 0 .2-.1.1-.3-.1-.3zm-22.9-3.5c-2.3 1.4-4.4 3.4-6.4 5.2-1.9 1.9-4.1 3.8-5.4 6.2-.1.2.1.3.3.2 2.1-1.8 3.7-4 5.7-5.9 2-1.9 4.2-3.5 6.2-5.4.1-.1-.2-.4-.4-.3zm-45.5 5.6c1 7.4 3.8 14.6 5 22.1 0 .1.1.1.1 0-.4-7.2-1-15.8-4.7-22.1-.1-.3-.5-.2-.4 0zm-2.7.6c-4 7.9-6.2 17.4-6.2 26.2 0 .2.4.3.4.1 1.3-9.1 3.3-17.3 6.3-26 .2-.4-.3-.6-.5-.3zm93.5 4.3c-2.5-8.2-4.1-15.7-4.3-24.3 0-.3-.4-.3-.5 0-.7 7.7.5 16.3 3.7 23.5-2.5-3.1-5.3-6.1-8.1-8.8-2-1.9-4.2-4.1-7.2-2.9-.3.1-.2.6.2.6 3.5-.8 6.7 4.4 8.9 6.5 2.2 2.1 4.3 4.4 6.6 6.3.3.2.8-.1.6-.4.1-.2.2-.3.1-.5zm-12.8-14.1c3.4-3.2 5.9-8.9 4.8-13.7-.1-.2-.4-.2-.4.1-.3 2.4-.3 4.8-1.2 7.1-.8 2.3-2.1 4.4-3.5 6.3-.1.1.2.3.3.2zm12.4-3.9c8.6 4.8 18.3 8.1 27.5 11.5.3.1.5-.4.2-.5-8.4-4.8-17.8-9.7-27.4-11.9-.4-.1-.8.6-.3.9z",
    fill: "#4d7e86",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11328",
    d: "M158.3 201.6c-.2 2.9-.3 5.7-.3 8.6v4.3c.1 1.4.1 2.9.2 4.3.1-1.4.2-2.9.3-4.3l.3-4.3.6-8.5c.2-2.8.5-5.6 1-8.4.3-1.4.6-2.8 1-4.1.4-1.4.8-2.7 1.4-4.1-1.4 2.5-2.4 5.2-3.1 8-.9 2.8-1.2 5.6-1.4 8.5zm-51.2-20.3c.6 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2-1.2-.5-1.2-1.2.6-1.2 1.2-1.2zm-6.2 14.4c.6 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2-1.2-.5-1.2-1.2.6-1.2 1.2-1.2zm-.1 17.1c.6 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2-1.2-.5-1.2-1.2.6-1.2 1.2-1.2zm15.7-31.9s.1-.1 0 0c.1-.1 0 0 0 0zm55 29.3c-.2-3.3-.5-6.6-.9-9.8-.4-3.3-1.3-6.5-2.3-9.7-.5-1.6-1.1-3.1-1.8-4.7-.4-.8-.7-1.5-1.2-2.3-.4-.5-.8-.8-1.3-1-.3-.1-.6-.2-.9-.2h-.4l-3.6-2.8c-.6-.5-1.4-1-2.1-1.4-.8-.4-1.5-.8-2.2-1.1-3-1.4-6.1-2.5-9.1-3.6l-4.6-1.7c-.8-.3-1.5-.6-2.2-.9-.2-.1-.4-.2-.5-.2-.1-.1-.3-.1-.5-.3-.4-.2-.8-.4-1.1-.6-2.8-1.4-5.7-2.5-8.6-3.7l.1-1.9c0-.2-.1-.4-.2-.5-.7-.5-1.4-1.1-2.1-1.7-.3-.3-.6-.6-.9-1-.3-.3-.5-.7-.7-1.1-.4-.8-.7-1.7-.9-2.6-.2-.9-.3-1.8-.5-2.7 0-.1-.1-.2-.2-.3-1-.8-2.2-.9-2.2-.9-.2 1.8.3 4.7.4 5.4 0 .2-.1.4-.1.6l-.7 4.9c-.1.8-.2 1.6-.4 2.4-.2.7-.5 1.5-.9 2.2-.8 1.4-1.6 2.8-2.7 4-2.3 2.3-5.3 3.6-8.2 5.1-.7.4-1.5.7-2.2 1.2-.4.2-.8.5-1 .9-.3.4-.4.8-.5 1.2-.5 1.6-.9 3.2-1.4 4.7l-.7 1.7-2.6-3.9c-1.1-1.5-1.9-3.3-3.6-4.6-.4-.3-.9-.6-1.5-.8-.3-.1-.7-.1-.9-.1h-.7l-2.8-.1c-.5 0-.9 0-1.4-.1-.2 0-.4 0-.6-.1-.1 0-.1-.1-.2-.2-.6-.6-1.2-1.3-1.7-2.1-.4-.6-.8-1.6-1.1-2.4l-1.1-2.6-2.1-5.2c-.6-1.7-1-3.6-1.5-5.4l-.5-1.6-.1-.3c.1-.2.2-.6.3-1.1.1-1 .2-4 .2-4s-2 .4-2.5.8c-.2.1-.5.3-.6.6l-.4 1.1v.1c-.2.8-.4 1.6-.7 2.3-.2.8-.5 1.5-.9 2.2-.3.6-.8 1.1-1.4 1.7-.6.5-1.2 1.1-1.8 1.5-.3.2-.4.6-.4.9l.2 1.6c-2.8 1.2-5.5 2.3-8.3 3.7-.4.2-.7.4-1.1.6l-.3.2-.2.1c-.1.1-.3.1-.5.2-.7.3-1.5.6-2.2.9l-4.6 1.7c-3.1 1.1-6.1 2.3-9.1 3.6-.8.3-1.5.7-2.2 1.1-.7.4-1.6.9-2.2 1.4l-3.5 2.8h-.4c-.3 0-.6.1-.9.2-.5.2-1 .5-1.3 1-.6.8-.9 1.6-1.2 2.3-.7 1.5-1.3 3.1-1.8 4.7-1 3.1-1.9 6.4-2.3 9.7-.4 3.3-.7 6.6-.9 9.8-.2 3.3-.4 6.6-.6 9.8h.2c.3-3.3.7-6.5 1.1-9.8.4-3.2.8-6.5 1.3-9.7.5-3.2 1.5-6.3 2.6-9.4l1.8-4.5c.3-.7.7-1.5 1.1-2 .1-.2.4-.4.6-.4.1 0 .2-.1.3-.1h.2l.6-.1c.4 1.2.8 2.4 1.2 3.7.4 1.5.8 2.9 1.1 4.4.7 3 1.2 6 1.6 9 .4 3 .8 6.1 1.1 9.1.2 1.5.3 3.1.5 4.6.2 1.5.3 3.1.4 4.6.2-3.1.1-6.2-.1-9.2-.2-3.1-.5-6.1-.9-9.2-.4-3.1-1-6.1-1.8-9.1-.8-2.7-1.7-5.4-3-8h.2l3.9-2.9c.7-.5 1.2-.9 1.9-1.2.7-.4 1.4-.7 2.2-1 3-1.2 6-2.3 9.1-3.5l4.6-1.7c.8-.3 1.5-.6 2.3-.9l.6-.3.3-.2.2-.1c.3-.2.7-.4 1-.5 2.7-1.3 5.6-2.5 8.4-3.7.1 1.4.2 2.8.1 4.1 0 1.3-.1 2.5-.2 3.8-.2 1.2-.4 2.4-.7 3.7-.5 2.5-.9 5.1-1.4 7.6-.5 2.5-.8 5.1-1.3 7.6 0 .3 0 .6.2.8.3.4 1 .4 1.4.1 1.5-1.3 2.9-2.7 4.3-4.1s2.8-2.8 4.1-4.2c.7-.7 1.3-1.5 1.9-2.3l.9-1.2c.2-.4.5-.8.8-1.1l.5-.5c2.3 1.4 4.8 2.3 7.4 2.9.9.2 1.9.4 2.8.5.6 1.8 1.4 3.4 2.3 5l.6 1.2c.2.4.3.9.6 1.3.3.7.7 1.4 1.1 2.2-.1.3-.2.5-.3.9-.2 1.4-.1 2.8-.1 4.1l.2 4c.1 1.3 0 2.6 0 4 0 1.3 0 2.7.1 4l.1 4c.1 1.3.1 2.7.2 4 .1-1.3.2-2.7.3-4l.2-4c.1-2.7.2-5.3.1-8.1-.1-1.4-.2-2.7-.2-4-.1-1.3-.2-2.7-.1-3.9 0-.5.4-1.2.7-1.8l.9-1.8c.5-1.1 1.1-2.1 1.5-3.1.3.1.6 0 .7-.3l1-2.6c.1-.3.1-.5.2-.8 1.1.1 2.1 0 3.2-.2.9-.1 1.8-.4 2.7-.6-1.4 2.6-2.8 5.2-4.1 7.8-.7 1.4-1.6 2.6-2.4 4-.4.7-.8 1.5-.8 2.4 0 .8 0 1.6.1 2.4.2 3.1.5 6.2.7 9.3.1 1.5.1 3.1.1 4.6.1 1.6.1 3.1.2 4.7.2-3.1.4-6.2.4-9.4-.1-3.1-.3-6.2-.5-9.3-.1-.8-.1-1.6-.1-2.3 0-.7.3-1.3.6-2 .7-1.3 1.6-2.7 2.2-4.1 1.2-2.7 2.4-5.4 3.5-8.2.3-.1.6-.2.8-.2 1.2-.4 2.3-.9 3.3-1.6 1-.6 1.9-1.4 2.8-2.2-1.1.5-2 1.1-3.1 1.5-1.1.5-2.2 1-3.3 1.4-2.1.8-4.2 1.3-6.4 1.8.3-1.3.7-2.6 1-3.8.1-.4.2-.8.4-1 .2-.3.5-.5.8-.7l2.1-1.2c.7-.3 1.3-.7 2-1 .9-.1 1.8-.1 2.7.1.6.1 1.1.3 1.5.7.5.4.9.8 1.3 1.2l1 1c1.3 1.4 2.5 3 3.8 4.5 1.7 2 3.7 3.4 5.7 4.9 2 1.5 4.1 2.8 6.2 4.1.2.1.5.2.7.1.5-.1.9-.6.7-1.2-.5-2.2-1.1-4.4-1.6-6.6s-1.1-4.4-1.7-6.6c-.6-2.2-1.2-4.4-1.7-6.6-.4-1.9-.8-3.8-1-5.7 2.7 1.2 5.5 2.4 8 3.8.4.2.7.4 1 .6.1.1.3.2.6.3s.4.2.6.3c.8.4 1.5.6 2.3.9l4.6 1.7 4.6 1.7c1.5.6 3 1.1 4.5 1.8.7.3 1.5.6 2.1 1 .7.4 1.3.7 1.9 1.2l3.9 2.9.9.1h.2c.1 0 .2 0 .4.1s.5.3.6.4c.4.5.8 1.3 1.1 2 .7 1.5 1.2 3 1.8 4.5 1.1 3.1 2.1 6.2 2.6 9.4s.9 6.5 1.3 9.7l1.1 9.8h.2c.2-3.2 0-6.5-.3-9.7zm-89.2-28.1c-.4.4-.7.7-1 1.1-.3.4-.6.7-.9 1.1-.7.7-1.4 1.4-2.1 2-1.4 1.4-2.9 2.6-4.3 3.9l-2.3 2.1c.3-1.6.6-3.2.8-4.9.4-2.5.8-5.1 1.2-7.6.2-1.2.4-2.6.5-3.9.1-1.3.1-2.6 0-3.9-.1-1.6-.3-3.1-.6-4.6.2-.2.3-.5.2-.8l-.2-1.8c.5-.4 1-.9 1.5-1.3.6-.6 1.3-1.3 1.8-2.2.4-.8.7-1.6.9-2.3l.5 1.8c.5 1.8.9 3.7 1.6 5.5l2.2 5.3 1.1 2.6.6 1.3.3.7c.1.2.3.5.4.7.6.9 1.2 1.6 2 2.3l.1.1c-1.5.8-3 1.6-4.3 2.8zm8.8 2c-2.5-.6-5-1.2-7.6-1.9.9-1 2.1-1.9 3.2-2.6l.1.1c.1.1.1.1.3.2.2.1.4.1.4.1.3.1.6.1.8.1H93.7c.3.1.7.3 1 .5 1.3 1 2.3 2.7 3.4 4.2l.5.6c-1.2-.2-2.4-.3-3.7-.5-1.2-.3-2.5-.5-3.8-.8zm8.7 8.3c-.3.6-.7 1.1-1 1.7-.2.3-.3.6-.5.8-.1-.7-.3-1.5-.5-2.2-.1-.5-.3-.9-.4-1.4-.2-.5-.4-.9-.6-1.4-.9-1.6-1.9-3.2-3.1-4.6.4 0 .8.1 1.2.1 1.3.1 2.6 0 3.8-.2l2.8 3.9c0 .1.1.1.2.1l-1.9 3.2zm28.3-15.3.7 3.3c.5 2.2 1 4.4 1.5 6.7.4 1.4.7 2.9 1 4.3-1.4-.9-2.8-1.8-4.1-2.7l-3-2.1c-1-.7-1.9-1.5-2.7-2.3-1.7-1.8-3.4-3.6-5.3-5.2-.5-.4-1-.8-1.5-1.1-.6-.4-1.2-.6-1.9-.6-.8-.1-1.5 0-2.2.2 2.1-1.1 4.2-2.3 5.9-4 1.2-1.2 2-2.7 2.8-4.1.4-.7.8-1.5 1-2.3.2-.8.3-1.6.5-2.4l.8-4.9c.1-.4.1-.8.2-1.2l.3-1.2.2-.6c.1.3.1.6.2 1 .2.9.5 1.9.9 2.8.2.4.4.9.7 1.3.3.4.6.8 1 1.1.6.6 1.2 1.2 1.9 1.7l-.2 2c0 .2.1.5.3.6 0 2.1.2 4.2.5 6.3.1 1.2.3 2.3.5 3.4z",
    fill: "#184f58",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-head",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath12382",
    d: "M65.1 101.2s-1.7-4.8-3.2-7.5-3.4-6-6.3-6.8c-2.9-.8-3.8 3.7-2.7 7.8 1.1 4.1 4 13.1 4.7 16.6s1.7 7.7 3.4 7.1 6.8-7.1 4.1-17.2z",
    fill: "#f3d4cf",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath12383",
    d: "M65.9 105.9c.1 1.6.1 3.2-.1 4.8-.5 3.1-1.8 6-3.8 7.9l-.4.3c-.2.1-.3.2-.5.3-.4.1-.9 0-1.3-.3-.7-.6-1.1-1.4-1.4-2.2-.6-1.6-.9-3.1-1.2-4.7-.3-1.5-.7-3-1.1-4.6l-1.2-4.6c-.4-1.5-.8-3-1.3-4.6l-.5-2.2c-.2-.8-.4-1.5-.6-2.3-.2-.8-.2-1.6-.2-2.4s.1-1.6.3-2.4.6-1.5 1.1-2c.6-.5 1.3-.6 2-.4 1.3.3 2.5 1.1 3.5 2.2s1.8 2.5 2.5 3.8c.7 1.4 1.3 2.8 1.9 4.3.6 1.5 1.1 2.9 1.6 4.4.3 1.6.6 3.1.7 4.7zM61.1 93c-.8-1.3-1.6-2.4-2.5-3.4s-2-1.7-3.1-2c-.5-.2-1-.1-1.5.2-.4.3-.8.8-1 1.5-.4 1.3-.5 2.9-.2 4.5.1.8.3 1.5.5 2.3s.4 1.5.7 2.3c.5 1.5 1 3 1.4 4.5.5 1.5 1 3 1.4 4.5.5 1.5.9 3 1.2 4.6.3 1.5.7 3.1 1.2 4.4.3.7.6 1.3.9 1.5.2.1.3.2.5.1.1 0 .2-.1.3-.2l.3-.3c.9-.8 1.6-1.9 2.3-3.1.6-1.2 1.1-2.5 1.5-3.9.7-2.8.6-6.1-.2-9.2-.9-3-2.1-5.8-3.7-8.3z",
    fill: "#e4b3ab",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath12384",
    d: "M53.8 89.9c1.8-.8 3.4 1.3 4.6 3.1 1.5 2.3 2.5 5.2 2.8 8.2v.2c0 .2 0 .5.1.7 0 .2-.2.2-.2 0-.1-.4-.2-.8-.3-1.3 0-.1-.1-.2-.2-.3-1.2-.6-1.7-.3-1.7.8 0 .7.1 1.4.3 2.1.3 1.1.8 2.2 1.2 3.3.1.2-.2.4-.3.2-.9-1.5-2.4-5-1.4-6.8.5-.9 1.3-.8 1.8-.2-.5-1.9-1.1-4.1-2.1-5.9-2 4.2-.9 8.7.1 13.4 0 .2-.2.3-.2.1-1.3-4.4-2.6-10.1 0-13.7-1.1-2.1-2.6-3.7-4.5-3.6-.1.1-.2-.2 0-.3z",
    fill: "#d4958a",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath12385",
    d: "M61.1 108.8c.1 1.1 0 2.2-.5 3-.1.1-.2 0-.1-.1.3-.9.6-1.8.5-2.9-.1-.1 0-.2.1 0z",
    fill: "#d4958a",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath12386",
    d: "M134.9 101.2s1.7-4.8 3.2-7.5 3.4-6 6.3-6.8c2.9-.8 3.8 3.7 2.7 7.8-1.1 4.1-4 13.1-4.7 16.6s-1.7 7.7-3.4 7.1-6.8-7.1-4.1-17.2z",
    fill: "#f3d4cf",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath12387",
    d: "M134.9 101.2c.5-1.5 1.1-2.9 1.6-4.4s1.2-2.9 1.9-4.3 1.5-2.7 2.5-3.8c1-1.1 2.2-2 3.5-2.2.7-.2 1.4 0 2 .4.6.5.9 1.2 1.1 2 .2.8.3 1.6.3 2.4s-.1 1.6-.2 2.4c-.1.8-.4 1.6-.6 2.3l-.6 2.3c-.4 1.5-.8 3-1.3 4.6l-1.2 4.6c-.4 1.5-.8 3-1.1 4.6s-.6 3.2-1.2 4.7c-.3.8-.6 1.6-1.4 2.2-.4.3-.9.4-1.3.3-.2-.1-.3-.2-.5-.3l-.4-.3c-2-1.9-3.3-4.8-3.8-7.9-.3-1.6-.3-3.2-.1-4.8.1-1.7.4-3.2.8-4.8zm.1.1c-.8 3-.9 6.3-.2 9.2.4 1.4.9 2.7 1.5 3.9.6 1.2 1.4 2.3 2.3 3.1l.3.3c.1 0 .2.1.3.2.2.1.3 0 .5-.1.3-.3.7-.9.9-1.5.5-1.3.9-2.9 1.2-4.4.3-1.6.8-3.1 1.2-4.6.5-1.5 1-3 1.4-4.5.5-1.5 1-3 1.4-4.5.2-.7.5-1.5.7-2.3s.4-1.5.5-2.3c.3-1.5.2-3.1-.2-4.5-.2-.6-.6-1.2-1-1.5s-1-.3-1.5-.2c-1.1.3-2.1 1.1-3.1 2-.9 1-1.7 2.2-2.5 3.4-1.4 2.5-2.6 5.3-3.7 8.3z",
    fill: "#e4b3ab",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath12388",
    d: "M146.2 89.9c-1.8-.8-3.4 1.3-4.6 3.1-1.5 2.3-2.5 5.2-2.8 8.2v.2c0 .2 0 .5-.1.7 0 .2.2.2.2 0 .1-.4.2-.8.3-1.3 0-.1.1-.2.2-.3 1.2-.6 1.7-.3 1.7.8 0 .7-.1 1.4-.3 2.1-.3 1.1-.8 2.2-1.2 3.3-.1.2.2.4.3.2.9-1.5 2.4-5 1.4-6.8-.5-.9-1.3-.8-1.8-.2.5-1.9 1.1-4.1 2.1-5.9 2 4.2.9 8.7-.1 13.4 0 .2.2.3.2.1 1.3-4.4 2.6-10.1 0-13.7 1.1-2.1 2.6-3.7 4.5-3.6.1.1.2-.2 0-.3z",
    fill: "#d4958a",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath12389",
    d: "M138.9 108.8c-.1 1.1 0 2.2.5 3 .1.1.2 0 .1-.1-.3-.9-.6-1.8-.5-2.9.1-.1 0-.2-.1 0z",
    fill: "#d4958a",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-wrap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11151",
    d: "M141 88.4c0 30.3-18.9 65.2-41 65.2s-41-34.9-41-65.2 18.9-47 41-47 41 16.6 41 47z",
    fill: "#f3d4cf",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11152",
    d: "M100 41.3c-22.1 0-41.1 16.7-41.1 47s19 65.5 41.1 65.5 41.1-35.2 41.1-65.5-19-47-41.1-47zm28.2 13.6.8.8c.3.3.5.6.8.9.3.3.5.6.8.9l.7.9c.2.3.5.6.7.9l.7 1 .3.5.3.5c.4.7.9 1.3 1.2 2l.6 1c.2.3.4.7.5 1l.5 1.1.5 1.1c.2.4.3.7.5 1.1l.4 1.1c2.3 5.9 3.2 12.4 3.3 18.7 0 6.4-.9 12.8-2.6 18.9-.8 3.1-1.9 6.1-3.1 9-1.2 2.9-2.5 5.8-4 8.6s-3.1 5.5-4.8 8.1c-.9 1.3-1.8 2.6-2.7 3.8-.9 1.2-1.9 2.4-3 3.6-2 2.3-4.3 4.4-6.7 6.3-2.4 1.8-5 3.3-7.8 4.3-1.4.5-2.8.9-4.3 1-1.5.2-2.9.2-4.4.1-3-.2-5.9-1.2-8.6-2.6-2.7-1.4-5.3-3.3-7.6-5.4-2.3-2.1-4.4-4.5-6.3-7.1s-3.6-5.3-5-8.1c-1.5-2.8-2.8-5.7-3.9-8.7-.6-1.5-1.1-3-1.6-4.5s-.9-3-1.3-4.6c-.8-3.1-1.4-6.2-1.8-9.3-.4-3.1-.7-6.3-.8-9.4 0-1.6 0-3.1.1-4.7 0-.8.1-1.6.1-2.3l.2-2.3c.3-3.1.9-6.2 1.7-9.1.8-3 1.8-5.9 3.2-8.6.2-.4.3-.7.5-1l.5-1c.4-.7.8-1.3 1.2-2 .4-.6.8-1.3 1.3-1.9l.7-.9.3-.5.4-.4c1.9-2.4 4.1-4.5 6.5-6.3s5-3.3 7.8-4.5 5.7-2 8.6-2.5c.7-.2 1.5-.2 2.2-.3.4-.1.8-.1 1.1-.1l1.1-.1c.8 0 1.5-.1 2.3-.1H102.6l1.1.1c.4 0 .8.1 1.1.1.4 0 .8.1 1.1.1l1.1.2.6.1.6.1 1.1.2c.4.1.7.2 1.1.3s.7.2 1.1.3c1.4.4 2.9.9 4.3 1.5s2.8 1.2 4.1 2c2.7 1.5 5.2 3.3 7.4 5.4l.4.4.5.3z",
    fill: "#c5796d",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath12453",
    d: "M87.3 127.9s2.9-.8 4.7-1.5 3.9-1.3 5.1-.9 2.9 1.5 3.7 1.5c.8-.1 2.2-.9 3.3-1.3 1.1-.4 3.2-.1 5.8 1 2.6 1.1 4.5 1.5 4.5 1.5s-6.2 4.3-8.5 5.1c-1.7.6-8.1.1-9.7-.1s-5.5-2.6-6.7-3.5-2.2-1.8-2.2-1.8z",
    fill: "#da7c87",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath12454",
    d: "M85.1 128c2.1 1.2 4.5 1 6.8.7 1.7-.2 3.3-.3 4.9.4 1 .4 1.9 1.2 3 1.4 2.1.3 4-1.6 6-2 3.1-.5 6.4.2 9.5.1 1 0 .8-1.5-.2-1.4-2.7.4-5.4-.2-8.1.2-2.7.4-5.6 3.2-8.3 2.1-1.9-.8-3.2-1.7-5.4-1.9-2.7-.3-5.3 0-7.9-.7-.5-.1-.8.8-.3 1.1z",
    fill: "#cb5f6c",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath12455",
    d: "M110.4 129.6c-1.3.7-2.5 1.5-3.9 2-1.2.4-2.5.7-3.8.9-.2 0-.1.3 0 .3 2.8.2 6-.8 8-2.8.1-.2-.1-.5-.3-.4z",
    fill: "#e99ca5",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath12456",
    d: "M103.9 126.5c1.2-.2 2.2-.1 3.4.1.2 0 .2-.2.1-.3-1.1-.6-2.4-.5-3.5-.1-.3 0-.2.3 0 .3z",
    fill: "#e99ca5",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11244",
    d: "M92.1 98.1s-3.5 2.7-5.9 3.2c-2.4.5-6.1.8-9.4-.1-3.2-1-4.9-2.8-4.9-2.8s1.4-2.6 3.4-3.6 4.1-2.6 8.6-1.9 7.3 3.7 8.2 5.2z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11186",
    d: "M82 91.2c2.9 0 5.2 2.3 5.2 5.2s-2.3 5.2-5.2 5.2-5.2-2.3-5.2-5.2 2.3-5.2 5.2-5.2z",
    fill: "#384b94",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11187",
    d: "M82 101.8c-3 0-5.4-2.4-5.4-5.4S79 91 81.9 91s5.4 2.4 5.4 5.4c.1 3-2.3 5.4-5.3 5.4zm-.1-10.2c-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9 4.9-2.2 4.9-4.9c0-2.8-2.2-5-4.9-4.9z",
    fill: "#253984",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11188",
    d: "M82 92c2.4 0 4.4 2 4.4 4.4s-2 4.4-4.4 4.4-4.4-2-4.4-4.4 2-4.4 4.4-4.4z",
    fill: "#43559b",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11189",
    d: "M82 92.6c2.1 0 3.8 1.7 3.8 3.8s-1.7 3.8-3.8 3.8-3.8-1.7-3.8-3.8 1.7-3.8 3.8-3.8z",
    fill: "#4e60a3",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11190",
    d: "M82 93.6c1.5 0 2.8 1.3 2.8 2.8s-1.3 2.8-2.8 2.8-2.8-1.3-2.8-2.8 1.3-2.8 2.8-2.8z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11191",
    d: "M80.7 93.6c.5 0 1 .4 1 1s-.4 1-1 1c-.5 0-1-.4-1-1s.5-1 1-1zm3.2 4.4c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4c.1-.2.2-.4.4-.4z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11252",
    d: "M70.7 98c0 6.9 4.9 12.5 11 12.5s11-5.6 11-12.5-4.9-12.5-11-12.5-11 5.6-11 12.5zm1.2.4s1.4-2.6 3.4-3.6 4.1-2.6 8.6-1.9c4.5.7 7.2 3.6 8.2 5.1 0 0-3.5 2.7-5.9 3.2-2.4.5-6.1.8-9.4-.1-3.2-.9-4.9-2.7-4.9-2.7z",
    fill: "#f3d4cf",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11253",
    d: "M91 96.6s-2.7-3.5-7.8-3.9c-5.1-.5-9.4 2.8-11.3 5.7 0 0-2 .5-3.3-.7 0 0 2 .1 4.3-2.1 2.1-2.1 5.6-4 9.8-3.4 4.5.5 6.4 1.8 8.3 4.4z",
    fill: "#e4b3ab",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11254",
    d: "M69.9 95.9c-.1-.1 0-.2.1-.2 1.2.7 2.2.7 3.3.2.4-.5.9-.9 1.4-1.3-1 0-2-.4-2.6-1.2-.1-.1.1-.2.1-.1.9.7 1.9 1.1 2.9 1 .6-.4 1.1-.7 1.8-1-.6-.3-1.1-.8-1.3-1.5 0-.1.1-.2.2-.1.4.6.9 1.1 1.6 1.4.7-.3 1.4-.5 2.1-.6-.1-.1-.2-.1-.2-.2-.2-.3-.5-.7-.5-1.1 0-.1.2-.2.3-.1.2.3.2.6.4.9.1.2.2.3.4.4 4.8-.7 10.1 1.5 12.6 6 .1.2-.2.4-.3.2-2.3-3.5-6.2-5.7-10.5-5.5-3.9.2-7.1 2.4-9.6 5.4 6.2 4.1 13.4 4 19.5-.2.1-.1.3.1.1.2-3.1 2.8-7.2 4-11.1 3.8-.1.1-.2.3-.2.4-.1.2-.1.3-.2.5-.1.1-.2.1-.2-.1 0-.3.1-.6.3-.9-.8-.1-1.6-.2-2.4-.4-.1.1-.3.2-.4.4-.1.2-.2.4-.4.6-.1.1-.2 0-.2-.1 0-.3.2-.5.3-.7.1-.1.2-.2.2-.3-.6-.2-1.3-.4-1.9-.7-.2.1-.4.2-.6.4l-.6.6c-.1.1-.2 0-.2-.1.2-.4.6-.8 1.1-1-.6-.3-1.2-.6-1.7-1-.2.1-.4.1-.6.3-.3.2-.5.4-.8.6-.1.1-.2 0-.2-.1.2-.5.8-.8 1.3-1-.4-.3-.9-.6-1.3-1l-.1.1c-.1.1-.3 0-.2-.2 0 0 0-.1.1-.1 0-.1 0-.1.1-.2.3-.6.6-1.2 1-1.8-1 .4-2.1.1-2.9-.6z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11245",
    d: "M107.9 98.1s3.5 2.7 5.9 3.2c2.4.5 6.1.8 9.4-.1 3.2-1 4.9-2.8 4.9-2.8s-1.4-2.6-3.4-3.6-4.1-2.6-8.6-1.9-7.3 3.7-8.2 5.2z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11192",
    d: "M118 91.2c2.9 0 5.2 2.3 5.2 5.2s-2.3 5.2-5.2 5.2-5.2-2.3-5.2-5.2 2.3-5.2 5.2-5.2z",
    fill: "#384b94",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11193",
    d: "M118.1 101.8c-3 0-5.4-2.4-5.4-5.4S115 91 118 91s5.4 2.4 5.4 5.4c.1 3-2.3 5.4-5.3 5.4zm-.1-10.2c-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9 4.9-2.2 4.9-4.9c0-2.8-2.2-5-4.9-4.9z",
    fill: "#253984",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11194",
    d: "M118 92c2.4 0 4.4 2 4.4 4.4s-2 4.4-4.4 4.4-4.4-2-4.4-4.4 2-4.4 4.4-4.4z",
    fill: "#43559b",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11195",
    d: "M118 92.6c2.1 0 3.8 1.7 3.8 3.8s-1.7 3.8-3.8 3.8-3.8-1.7-3.8-3.8 1.7-3.8 3.8-3.8z",
    fill: "#4e60a3",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11196",
    d: "M118 93.6c1.5 0 2.8 1.3 2.8 2.8s-1.3 2.8-2.8 2.8-2.8-1.3-2.8-2.8 1.3-2.8 2.8-2.8z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11197",
    d: "M116.8 93.6c.5 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zM120 98c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4.2-.4.4-.4z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11255",
    d: "M118.3 85.5c-6.1 0-11 5.6-11 12.5s4.9 12.5 11 12.5 11-5.6 11-12.5-5-12.5-11-12.5zm4.9 15.7c-3.2 1-7 .6-9.4.1-2.4-.5-5.9-3.2-5.9-3.2.9-1.5 3.6-4.4 8.2-5.1 4.5-.7 6.7.9 8.6 1.9 2 1 3.4 3.6 3.4 3.6s-1.7 1.7-4.9 2.7z",
    fill: "#f3d4cf",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11258",
    d: "M109 96.6s2.7-3.5 7.8-3.9c5.1-.5 9.4 2.8 11.3 5.7 0 0 2 .5 3.3-.7 0 0-2 .1-4.3-2.1-2.1-2.1-5.6-4-9.8-3.4-4.5.5-6.4 1.8-8.3 4.4z",
    fill: "#e4b3ab",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11259",
    d: "M130.1 95.9c.1-.1 0-.2-.1-.2-1.2.7-2.2.7-3.3.2-.4-.5-.9-.9-1.4-1.3 1 0 2-.4 2.6-1.2.1-.1-.1-.2-.1-.1-.9.7-1.9 1.1-2.9 1-.6-.4-1.1-.7-1.8-1 .6-.3 1.1-.8 1.3-1.5 0-.1-.1-.2-.2-.1-.4.6-.9 1.1-1.6 1.4-.7-.3-1.4-.5-2.1-.6.1-.1.2-.1.2-.2.2-.3.5-.7.5-1.1 0-.1-.2-.2-.3-.1-.2.3-.2.6-.4.9-.1.2-.2.3-.4.4-4.8-.7-10.1 1.5-12.6 6-.1.2.2.4.3.2 2.3-3.5 6.2-5.7 10.5-5.5 3.9.2 7.1 2.4 9.6 5.4-6.2 4.1-13.4 4-19.5-.2-.1-.1-.3.1-.1.2 3.1 2.8 7.2 4 11.1 3.8.1.1.2.3.2.4.1.2.1.3.2.5.1.1.2.1.2-.1 0-.3-.1-.6-.3-.9.8-.1 1.6-.2 2.4-.4.1.1.3.2.4.4.1.2.2.4.4.6.1.1.2 0 .2-.1 0-.3-.2-.5-.3-.7-.1-.1-.2-.2-.2-.3.6-.2 1.3-.4 1.9-.7.2.1.4.2.6.4l.6.6c.1.1.2 0 .2-.1-.2-.4-.6-.8-1.1-1 .6-.3 1.2-.6 1.7-1 .2.1.4.1.6.3.3.2.5.4.8.6.1.1.2 0 .2-.1-.2-.5-.8-.8-1.3-1 .4-.3.9-.6 1.3-1l.1.1c.1.1.3 0 .2-.2 0 0 0-.1-.1-.1 0-.1 0-.1-.1-.2-.3-.6-.6-1.2-1-1.8 1 .4 2.1.1 2.9-.6z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-facehighlight-single"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-rotate",
    transform: "matrix(1,1.7453292519943295e-9,-1.7453292519943295e-9,1,1.4906274259374186e-7,-1.399747446839683e-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath12149",
    d: "m69.1 87.3.2-.2.3-.3v-.1c.1-.2.2-.4.4-.5.3-.4.7-.7 1-.9.7-.6 1.4-1.2 2.3-1.4h.2c1.6-1.3 4-2.5 5.7-1.4 1.7-.2 3.5-.1 5 .4.8-.1 1.5.2 2.3.5 1.3.4 2.6.8 3.7 1.4.1.1.2.2.2.3 1.5.4 3 2.1 1.5 3.5-.8.7-1.8.7-2.7.3-.2-.1-.4-.1-.6-.2-1.7-.1-3.2-1.3-4.8-1.9-1.2-.5-2.5-.7-3.7-1-.9.1-1.7.2-2.6.3-.3 0-.6.1-.9.1-1.1.4-2.1.6-3.2.8-.2.1-.4.2-.7.3-.2.2-.6.3-.8.4-.1.1-.3.1-.4.2l-.9.3c-.3.1-.6.2-.9.2-.1 0-.3 0-.4-.1-.1 0-.1.1-.2.1-.3.1-.6-.1-.6-.4.1-.5.3-.7.6-.7z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath12150",
    d: "M88.3 87.9c.6-.2 1.3-.2 1.8-.6.6-.4 1-1 1.1-1.6.1-.2.4-.1.4.1-.2 1.4-1.7 3.2-3.3 2.5-.2 0-.2-.4 0-.4zm.5.9c1.4-.2 2.5-.7 3.3-1.9.1-.2.4-.1.3.2-.6 1.4-2.1 2.6-3.7 2.1-.1-.1-.1-.4.1-.4zm-3.7-6.3c-.1-.2.1-.5.3-.3 1.5 1.1 2.3 3.8.7 5.1-.2.1-.4 0-.3-.2.4-.7.7-1.8.5-2.6-.2-.8-.9-1.3-1.2-2zm-4.9-.2c1.9.1 3.2 2 3.5 3.8 0 .2-.2.3-.3.1-.4-.8-.7-1.7-1.4-2.3-.6-.6-1.3-.9-2-1.2-.1-.2 0-.5.2-.4zM72.4 84c2.6-1.7 6.2-.6 8.4 1.3.1.1 0 .2-.1.1-2.8-1.5-5.1-2.1-8.2-1.1-.2.1-.3-.2-.1-.3zm-3.6 3.7c1.8-2 5.2-2.7 7.8-1.9.1 0 .1.3 0 .2-1.2-.1-2.6 0-3.8.2-1.4.3-2.4 1.2-3.7 1.8-.3.1-.4-.2-.3-.3z",
    fill: "#3a353a",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath12151",
    d: "M92.9 87.5c0-.3 0-.5-.1-.7 0-.5-.2-1-.7-1.3-.6-.8-1.6-1.3-2.5-1.7-2.5-1.2-5.4-2-8.2-2.2-4.8-.4-10 1.2-12.8 5.3-.1 0-.2 0-.3.1-.4.5-.4 1.1.2 1.6.9.8 2.3 0 3.2-.3 3.6-1.4 7.3-2.7 11.2-1.5 1.8.6 3.4 1.6 5.2 2.3 1 .4 2.2.6 3.2.1.6-.3 1-.8 1.2-1.4.3-.1.4-.1.4-.3zm-17-4.6s.1 0 0 0c2.2.5 3.8 1 5.5 2.4.1.1.3 0 .2-.2-1-1.3-2.6-2.3-4.2-2.6.9-.2 1.8-.2 2.7-.2v.1c.6.5 1.1.9 1.6 1.5.4.6.6 1.2.8 1.8-.6-.2-1.1-.3-1.7-.3-1.8-.2-3.7.1-5.4.6-1 .3-2 .7-2.9 1-.4.2-2.9 1.5-3.5.5.1 0 .1 0 .2-.1 1.7-2.2 4.1-3.7 6.7-4.5zm9.5.1c-.1.6.1 1.1.1 1.7 0 .7-.3 1.2-.5 1.8v.2c-.7-.3-1.4-.6-2.1-.8 0-1.3-.9-2.8-2.1-3.5 1.6 0 3.1.2 4.6.6zm6.9 3.6c.2 1-.9 1.9-1.9 2.1-.6.1-1.4-.2-1.9-.4-.3-.1-.6-.3-.9-.4.4-.2.9-.5 1.2-.8.7-.6 1.1-1.3 1.2-2.2 0-.2-.2-.2-.2-.1-.3.7-.7 1.3-1.3 1.8-.5.4-1.1.6-1.6.9-.4-.2-.8-.4-1.3-.6-.1 0-.1 0-.2-.1 0 0 .1 0 .1-.1.8-.6 1.2-2.8.4-3.6.6.2 1.2.3 1.7.5 1.1.4 2.4.8 3.3 1.5-.1.6-.4 1.2-.9 1.7-.5.4-1 .6-1.6.8-.2.1-.2.3 0 .4.7.2 1.6-.2 2.1-.8.5-.5.8-1.2.8-1.9.3.4.7.8 1 1.3z",
    fill: "#1b141c",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-rotate",
    transform: "matrix(1,1.7453292519943295e-9,-1.7453292519943295e-9,1,1.4922410684903298e-7,-2.0942947287494462e-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath12152",
    d: "m130.9 87.3-.2-.2-.3-.3v-.1c-.1-.2-.2-.4-.4-.5-.3-.4-.7-.7-1-.9-.7-.6-1.4-1.2-2.3-1.4h-.2c-1.6-1.3-4-2.5-5.7-1.4-1.7-.2-3.5-.1-5 .4-.8-.1-1.5.2-2.3.5-1.3.4-2.6.8-3.7 1.4-.1.1-.2.2-.2.3-1.5.4-3 2.1-1.5 3.5.8.7 1.8.7 2.7.3.2-.1.4-.1.6-.2 1.7-.1 3.2-1.3 4.8-1.9 1.2-.5 2.5-.7 3.7-1 .9.1 1.7.2 2.6.3.3 0 .6.1.9.1 1.1.4 2.1.6 3.2.8.2.1.4.2.7.3.2.2.6.3.8.4.1.1.3.1.4.2l.9.3c.3.1.6.2.9.2.1 0 .3 0 .4-.1.1 0 .1.1.2.1.3.1.6-.1.6-.4-.1-.5-.3-.7-.6-.7z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath12153",
    d: "M111.7 87.9c-.6-.2-1.3-.2-1.8-.6-.6-.4-1-1-1.1-1.6-.1-.2-.4-.1-.4.1.2 1.4 1.7 3.2 3.3 2.5.2 0 .2-.4 0-.4zm-.5.9c-1.4-.2-2.5-.7-3.3-1.9-.1-.2-.4-.1-.3.2.6 1.4 2.1 2.6 3.7 2.1.1-.1.1-.4-.1-.4zm3.7-6.3c.1-.2-.1-.5-.3-.3-1.5 1.1-2.3 3.8-.7 5.1.2.1.4 0 .3-.2-.4-.7-.7-1.8-.5-2.6.2-.8.9-1.3 1.2-2zm4.9-.2c-1.9.1-3.2 2-3.5 3.8 0 .2.2.3.3.1.4-.8.7-1.7 1.4-2.3.6-.6 1.3-.9 2-1.2.1-.2 0-.5-.2-.4zm7.8 1.7c-2.6-1.7-6.2-.6-8.4 1.3-.1.1 0 .2.1.1 2.8-1.5 5.1-2.1 8.2-1.1.2.1.3-.2.1-.3zm3.6 3.7c-1.9-2-5.2-2.7-7.8-1.9-.1 0-.1.3 0 .2 1.2-.1 2.6 0 3.8.2 1.4.3 2.5 1.2 3.7 1.8.3.1.4-.2.3-.3z",
    fill: "#3a353a",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath12154",
    d: "M107.3 87.7c.2.6.6 1.1 1.2 1.4 1 .5 2.2.3 3.2-.1 1.8-.7 3.4-1.7 5.2-2.3 3.9-1.2 7.6.1 11.2 1.5.9.4 2.3 1.1 3.2.3.6-.5.6-1.1.2-1.6-.1-.1-.2-.1-.3-.1-2.8-4.1-8.1-5.7-12.8-5.3-2.8.2-5.6 1-8.2 2.2-.9.4-1.8 1-2.5 1.7-.4.3-.7.8-.7 1.3-.1.2-.1.5-.1.7.2.3.3.3.4.3zm23.6-.2c0 .1.1.1.1.1-.5.9-3.1-.4-3.5-.5-1-.4-1.9-.7-2.9-1-1.8-.5-3.6-.8-5.4-.6-.6.1-1.1.2-1.7.3.2-.6.4-1.3.8-1.8.4-.6 1-1.1 1.6-1.5v-.1c.9 0 1.8.1 2.7.2-1.7.2-3.3 1.3-4.2 2.6-.1.1.1.2.2.2 1.6-1.4 3.3-1.9 5.4-2.3 0 0 .1 0 .1-.1 2.6.7 5 2.2 6.8 4.5zm-11.7-5.2c-1.2.7-2.1 2.2-2.1 3.5-.7.2-1.4.5-2.1.8v-.2c-.1-.6-.4-1.2-.5-1.8 0-.5.2-1.1.1-1.6v-.1c1.5-.3 3-.5 4.6-.6zm-10.4 3c0 .7.3 1.4.8 1.9s1.3 1 2.1.8c.2-.1.2-.3 0-.4-.6-.2-1.1-.4-1.6-.8s-.8-1-.9-1.7c1-.7 2.2-1.1 3.3-1.5.6-.2 1.1-.3 1.7-.5-.8.8-.5 3 .4 3.6 0 0 .1 0 .1.1-.1 0-.1 0-.2.1-.4.2-.9.4-1.3.6-.5-.3-1.1-.4-1.6-.9-.6-.5-1-1.1-1.3-1.8-.1-.2-.3-.1-.2.1.1.9.5 1.6 1.2 2.2.3.3.7.6 1.2.8-.3.2-.6.3-.9.4-.5.2-1.3.6-1.9.4-1.1-.2-2.1-1.1-1.9-2.1.2-.5.6-.9 1-1.3z",
    fill: "#1b141c",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11288",
    d: "M97.72 89.37c-.8 3.33-.91 6.89-1.27 10.29-.38 3.64-1.08 7.4-1.03 11.06 0 .29.45.37.52.07.74-3.34.83-6.91 1.18-10.31.37-3.64 1.05-7.41.93-11.06 0-.19-.28-.24-.33-.05z",
    fill: "#c5796d",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 2)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11289",
    d: "M94.71 108.8c-.98 1.31-1.8 2.73-2.52 4.2-.46.95-1.04 2.07-.73 3.16.5 1.8 2.79 2.36 4.28 1.51.44-.26.24-.95-.26-.95-.87-.01-1.89.27-2.58-.47-.84-.89-.01-2.5.36-3.4.55-1.32 1.22-2.59 1.74-3.92.07-.19-.19-.26-.29-.13z",
    fill: "#c5796d",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 2)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11290",
    d: "M94.57 116.21c2.7-.2 3.21 3.2 5.78 3.28 2.2.07 2.37-3.24 4.46-3.14.24.01.32-.33.12-.45-2.37-1.4-2.81 2.72-4.99 2.46-1.29-.15-2.21-2.05-3.37-2.6-.79-.37-1.36-.34-2.13.01-.19.11-.09.46.13.44z",
    fill: "#c5796d",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 2)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11291",
    d: "M104.07 117.75c1.78.4 3.85-.15 4.27-2.13.21-.99-.12-1.97-.64-2.81-.84-1.37-1.93-2.53-2.73-3.95-.13-.24-.47-.12-.48.13-.1 1.59 1.08 2.69 1.92 3.92.78 1.13 1.45 2.69.14 3.81-.6.51-1.74.42-2.48.56-.24.05-.23.42 0 .47z",
    fill: "#c5796d",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 2)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11292",
    d: "M102.32 112.41c-.39-.7-1.4-.81-1.96-.25-.05.05-.23.28-.28.34-.06.08-.19.25-.21.28-.06.1-.12.2-.17.3l-.11.26c0-.01-.01.01-.03.05-.06.06-.12.13-.17.19-.17.18-.34.36-.48.57-.4.63-.08 1.35.46 1.75.83.62 2.03.12 2.61-.58.7-.84.89-1.92.34-2.91z",
    fill: "#fbe5e2",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 2)",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-front"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11806",
    d: "M145.8 79.1c-6.6-37.7-19.9-40.4-23.5-41.7-3.3-1.2-11.7-2.2-22 3-3-4-17.7-4.4-21.3-3s-18.8 6.2-24.8 44.9c-4.5 29.3.6 83.5.6 83.5 9.3 4.5 21.5 5.3 21.5 5.3s-2.7-16.4-6.5-42.9.4-47.5 3.5-57.8C76.4 60 80 55.6 84.6 54.6c4.3-1 14.4 2.9 16 3.5v.1h.2v-.1c1.6-.6 11.7-4.5 16-3.5 4.6 1 7.2 6.3 10.3 16.7 3.1 10.3 8.3 30.4 4.4 56.9-3.9 26.5-6.5 42.9-6.5 42.9s12.2-.8 21.5-5.3c-.1 0 4.3-57.6-.7-86.7z",
    fill: "#2e2116",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11807",
    d: "M131.4 128.6c1-5.2 2.1-14 2.5-28.2.7-26.4-10.7-47.2-14.3-50.2s-19 7.5-19 7.5-11.5-6.6-16.2-7.5c-4.7-.9-8.2 2.1-11.6 12.3s-5.5 23-5.4 39.1c.1 11.2 1.7 22.5 2.6 28.2-.1-.6-.2-1.1-.2-1.7-3.9-26.5.4-47.5 3.5-57.8 3.1-10.4 6.7-14.8 11.3-15.8 4.3-1 14.4 2.9 16 3.5v.1h.2V58c1.6-.6 11.7-4.5 16-3.5 4.6 1 7.2 6.3 10.3 16.7 3.1 10.3 8.3 30.4 4.4 56.9-.1.3-.1.4-.1.5zM99.5 54s-9-6.2-14.3-7.4S73.9 50.3 72 58.4c0 0-.2-4.2 4.6-10.8 4.9-6.8 15.3.2 22.9 6.4zm1.4.9s.2-8.5 0-13.2c0 .1-.9 6.5 0 13.2zm3.7-3.2s6.5-5.1 12-5.8c5.5-.7 10.8 10.8 10.8 10.8s-6.2-9.7-9.9-9.5c-3.7.3-12.9 4.5-12.9 4.5zM133 73.6s4.9 21.7 2.5 46.2-6 47.8-6 47.8 5.8-22.6 7.6-45.3c1.9-22.6-4.1-48.7-4.1-48.7zm7.6-.7s3.2 30.5 2.8 50.6c-.5 20.1-1.9 39.5-1.9 39.5s2.8-23.8 3-43.9c.3-20-3.9-46.2-3.9-46.2zM64.9 92.6s-.5 49 7.4 74.6c0 0-5.8-13.6-7.6-39.3-1.9-25.6.2-35.3.2-35.3zm-.2 74.1s-5.5-23.6-6-45.5c0 0-3 22.9 6 45.5zm8-121.5S57.6 64.5 57.4 93.5c0 0-3.2-27.6 15.3-48.3z",
    fill: "#1f140c",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath11808",
    d: "M101.8 54.8s9.9-7.7 15.7-7.5c5.8.2 12 12.9 15.9 29.5s1.3 65-4.9 89.8c0 0 5.4-39.1 5.7-52.8.3-13.7.5-30-4.7-47.4-5.2-17.3-10.6-17.6-12.7-17.9-2-.2-15 6.3-15 6.3zm-3.3.8s-8.5-9.3-17.1-8c-8.6 1.2-13.5 24-15.3 41.4-1.8 17.3 4.4 66 8.3 79.5 0 0-4.4-32.1-5.7-44-1.3-11.9-2.1-33.7.3-46.1s6.7-24.1 9.6-27.4c2.8-3.5 10-2.9 19.9 4.6zM61.4 77.3s-4.7 39.6 4.9 87c.1 0-7.2-52-4.9-87zM136 75s7.5 32.4.3 89.3c0 0 9.8-56.7-.3-89.3zm-25.1-30.8s4.7-2.7 7.8-2.1c6 1.3 7 5.7 7 5.7s-2.9-7-14.8-3.6z",
    fill: "#3d2f23",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "svga-credit-rect",
    width: 200,
    height: 15,
    x: 0,
    y: 185,
    fill: "#ecf0f1",
    opacity: 0.5,
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "svga-credit-text",
    fontFamily: "Avenir Next, Roboto, Helvetica, Arial, sans-serif",
    fontSize: "10px",
    textAnchor: "start",
    fontWeight: 400,
    size: "10px",
    anchor: "start",
    weight: 400,
    fill: "#333333",
    x: 33.40447998046875,
    y: 182.60824704170227,
    style: {
      display: "none"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "SvgjsTspan11101",
    dy: 13,
    x: 33.40447998046875
  }, "Created on AvatarMaker.com")))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs11053"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.2359ea763565826a13e05c8c090a40f3.svg";
export { ForwardRef as ReactComponent };